export default {
    populateNavigation,
};

const allNavItems = {
    home: { name: 'Home', route: '/home', icon: 'system-home-outline' },
    dashboard: { name: 'Dashboard', route: '/dashboard', icon: 'system-dashboard' },
    orders: { name: 'Leads', route: '/orders', icon: 'system-leaderboard' },
    jobs: { name: 'Jobs', route: '/jobs', icon: 'system-box-addon' },
    scheduler: {
        name: 'Schedule',
        icon: 'system-calendar',
        subitems: {
            diary: { name: 'Diary', route: '/scheduler/diary' },
            conflicts: { name: 'Fix list', route: '/scheduler/fix-list' },
            swimlane: { name: 'Swimlane', route: '/scheduler/swimlane' },
            runs: { name: 'Runs', route: '/scheduler/runs' },
        },
    },
    routes: { name: 'Routes', route: '/routes', icon: 'system-route' },
    finance: {
        name: 'Finance',
        icon: 'system-payment',
        subitems: {
            transactions: { name: 'Payments', route: '/finance' },
            disputes: { name: 'Transactions', route: '/transactions' },
            payouts: { name: 'Payouts', route: '/payouts' },
            purchase_orders: { name: 'Purchase orders', route: '/purchase-orders' },
        },
    },
    tenants: { name: 'Organisations', route: '/tenants', icon: 'system-companies' },
    users: { name: 'Users', route: '/users', icon: 'system-staff' },
    companies: { name: 'Companies', route: '/companies', icon: 'system-companies' },
    costs: {
        name: 'Costs & Pricing',
        icon: 'system-money',
        subitems: {
            rate_cards: { name: 'Rate cards', route: '/rate-cards' },
            interstate: { name: 'Interstate', route: '/interstate' },
            local: { name: 'Local', route: '/local' },
        },
    },
    depots: { name: 'Depots', route: '/depots', icon: 'system-depot' },
    fleet: {
        name: 'Fleet',
        icon: 'system-truck',
        subitems: {
            transport: { name: 'Transport', route: '/transport' },
            containers: { name: 'Containers', route: '/containers' },
            trailers: { name: 'Trailers', route: '/trailers' },
        },
    },
    storage: {
        name: 'Storage',
        icon: 'system-box',
        subitems: {
            units: { name: 'Units', route: '/storage' },
            jobs: { name: 'Jobs', route: '/storage/jobs' },
        },
    },
    staff: {
        name: 'Team',
        icon: 'system-staff',
        subitems: {
            payroll: { name: 'Payroll', route: '/staff/payroll' },
            team_directory: { name: 'Team directory', route: '/staff/team-directory' },
            timesheet_management: { name: 'Manage timesheets', route: '/staff/timesheet-management' },
        },
    },
    customers: { name: 'Customers', route: '/customers', icon: 'system-user-outline' },
    affiliates: { name: 'Affiliates', route: '/affiliates', icon: 'system-affiliates' },
    // affiliates: {
    //     name: 'Affiliates',
    //     icon: 'system-affiliates',
    //     subitems: {
    //         partners: { name: 'Partners', route: '/affiliates' },
    //         leads: { name: 'Leads', route: '/affiliates/leads' },
    //     },
    // },
    providers: { name: 'Providers', route: '/providers', icon: 'system-providers' },
    communications: {
        name: 'Communications',
        icon: 'system-email-outline',
        subitems: {
            templates: { name: 'Templates', route: '/communication' },
            automations: { name: 'Automations', route: '/automations' },
        },
    },
    forms: { name: 'Forms', route: '/forms', icon: 'system-document' },
    tools: {
        name: 'Tools',
        icon: 'system-tools',
        subitems: {
            other_insurance: { name: 'Covers with other', route: '/tools/other-insurance' },
            development: { name: 'Development', route: '/development' },
        },
    },
    timesheets: { name: 'My timesheets', route: '/staff/timesheets', icon: 'system-time-in-dark' },
    schedule: { name: 'Schedule', route: '/field-staff/schedule', icon: 'system-calendar' },
    runsheets: { name: 'Runsheets', route: '/field-staff/runsheets', icon: 'system-clipboard' },
    settings: { name: 'Global settings', route: '/settings/global', icon: 'system-settings' },
    help: { name: 'Help', route: '/help', icon: 'system-support' },
    quotes: { name: 'Quotes', route: '/quotes', icon: 'system-quote' },
    reports: { name: 'Reports', route: '/reports', icon: 'system-reports' },
    migration: { name: 'Migration', route: '/migration', icon: 'system-migration' },
    waybills: { name: 'Waybills', route: '/waybills', icon: 'system-clipboard' },
};

const centralContextNav = {
    SUPER: [
        'dashboard',
        'tenants',
        'migration',
        'communications:templates',
        'communications:automations',
        'users',
        'reports',
        'settings',
    ],
    MOVEPRO_ADMIN: [
        'dashboard',
        'tenants',
        'migration',
        'communications:templates',
        'communications:automations',
        'users',
        'reports',
        'settings',
    ],
    ADMIN: ['dashboard', 'reports'],
    OWNER: ['dashboard', 'reports'],
    MANAGER: ['dashboard', 'reports'],
    FINANCE: ['dashboard'],
    SALES: ['dashboard'],
    OPS: ['dashboard'],
    DEVELOPER: [
        'dashboard',
        'tenants',
        'migration',
        'communications:templates',
        'communications:automations',
        'users',
        'reports',
        'settings',
    ],
};

const tenantContextNav = {
    SUPER: [
        'dashboard',
        'orders',
        'jobs',
        // 'jobs:ancillary',
        'scheduler:diary',
        'scheduler:conflicts',
        'scheduler:swimlane',
        'scheduler:runs',
        'waybills',
        // 'routes',
        'finance:transactions',
        'finance:disputes',
        'finance:payouts',
        // 'finance:coupons',
        // 'companies',
        'depots',
        'costs:rate_cards',
        'costs:interstate',
        'costs:local',
        'fleet:transport',
        'fleet:containers',
        'fleet:trailers',
        'storage:units',
        'storage:jobs',
        'communications:templates',
        'communications:automations',
        'staff:team_directory',
        'customers',
        'affiliates',
        // 'affiliates:partners',
        // 'affiliates:leads',
        // 'providers',
        'forms',
        'reports',
        // 'tools:other_insurance',
        // 'settings',
        'help',
    ],
    MOVEPRO_ADMIN: [
        'dashboard',
        'orders',
        'jobs',
        // 'jobs:ancillary',
        'scheduler:diary',
        'scheduler:swimlane',
        'scheduler:runs',
        'waybills',
        // 'routes',
        'finance:transactions',
        'finance:disputes',
        'finance:payouts',
        'finance:purchase_orders',
        // 'finance:coupons',
        // 'companies',
        'depots',
        'costs:rate_cards',
        'costs:interstate',
        'costs:local',
        'fleet:transport',
        'fleet:containers',
        'fleet:trailers',
        'storage:units',
        'storage:jobs',
        'communications:templates',
        'communications:automations',
        'staff:team_directory',
        'customers',
        'affiliates',
        // 'affiliates:partners',
        // 'affiliates:leads',
        // 'providers',
        'forms',
        'reports',
        // 'tools:other_insurance',
        // 'settings',
        'help',
    ],
    OWNER: [
        'dashboard',
        'orders',
        'jobs',
        // 'jobs:ancillary',
        'scheduler:diary',
        'scheduler:conflicts',
        'scheduler:swimlane',
        'scheduler:runs',
        'waybills',
        // 'routes',
        'finance:transactions',
        'finance:disputes',
        'finance:payouts',
        'finance:purchase_orders',
        // 'finance:coupons',
        // 'companies',
        'depots',
        'costs:rate_cards',
        'costs:interstate',
        'costs:local',
        'fleet:transport',
        'fleet:containers',
        'fleet:trailers',
        'storage:units',
        'storage:jobs',
        'communications:templates',
        'communications:automations',
        'staff:payroll',
        'staff:team_directory',
        'staff:timesheet_management',
        'customers',
        'forms',
        'reports',
        'affiliates',
        // 'affiliates:partners',
        // 'affiliates:leads',
        // 'providers',
        // 'tools:other_insurance',
        // 'settings',
        'help',
    ],
    ADMIN: [
        'dashboard',
        'orders',
        'staff:payroll',
        'staff:team_directory',
        'staff:timesheet_management',
        'customers',
        'timesheets',
        'jobs',
        // 'jobs:ancillary',
        'scheduler:diary',
        'scheduler:conflicts',
        'scheduler:swimlane',
        'scheduler:runs',
        'waybills',
        // 'routes',
        'finance:transactions',
        'finance:disputes',
        'finance:purchase_orders',
        // 'finance:payouts',
        // 'finance:coupons',
        // 'companies',
        'depots',
        'costs:rate_cards',
        'costs:interstate',
        'costs:local',
        'fleet:transport',
        'fleet:containers',
        'fleet:trailers',
        'storage:units',
        'storage:jobs',
        'communications:templates',
        'communications:automations',
        'forms',
        'reports',
        'affiliates',
        // 'affiliates:partners',
        // 'affiliates:leads',
        // 'providers',
        // 'tools:other_insurance',
        // 'settings',
        'help',
    ],
    MANAGER: [
        'dashboard',
        'orders',
        'staff:payroll',
        'staff:team_directory',
        'staff:timesheet_management',
        'customers',
        'timesheets',
        'jobs',
        // 'jobs:ancillary',
        'scheduler:diary',
        'scheduler:conflicts',
        'scheduler:swimlane',
        'scheduler:runs',
        'waybills',
        'finance:purchase_orders',
        // 'routes',
        // 'finance:payouts',
        // 'companies',
        'depots',
        'costs:rate_cards',
        'costs:interstate',
        'costs:local',
        'fleet:transport',
        'fleet:containers',
        'fleet:trailers',
        'storage:units',
        'storage:jobs',
        // 'staff',
        // 'providers',
        'communications:templates',
        'communications:automations',
        'forms',
        'reports',
        // 'settings',
        'help',
    ],
    FINANCE: [
        'dashboard',
        'orders',
        'timesheets',
        'jobs',
        'finance:transactions',
        'finance:disputes',
        'finance:payouts',
        'finance:purchase_orders',
        'settings',
    ],
    SALES: [
        'dashboard',
        'orders',
        'timesheets',
        'jobs',
        // 'jobs:ancillary',
        // 'companies',
        // 'interstate',
        'scheduler:diary',
        'scheduler:conflicts',
        'scheduler:swimlane',
        'scheduler:runs',
        'storage:units',
        'storage:jobs',
        // 'depots',
        // 'fleet',
        // 'providers',
        // 'settings',
        'help',
    ],
    OPS: [
        'dashboard',
        'orders',
        'timesheets',
        'jobs',
        // 'jobs:ancillary',
        // 'companies',
        // 'costs:interstate',
        'scheduler:diary',
        'scheduler:conflicts',
        'scheduler:swimlane',
        'scheduler:runs',
        'waybills',
        'finance:purchase_orders',
        'depots',
        'costs:rate_cards',
        'costs:interstate',
        'costs:local',
        'fleet:transport',
        'fleet:containers',
        'fleet:trailers',
        'storage:units',
        'storage:jobs',
        // 'providers',
        // 'settings',
        'help',
    ],
    FIELD_STAFF: ['home', 'jobs', 'timesheets', 'schedule', 'runsheets', 'forms'],
    CONTRACTOR: ['home', 'schedule', 'runsheets', 'forms'],
    DEVELOPER: [
        'dashboard',
        'orders',
        'jobs',
        'scheduler:diary',
        'scheduler:swimlane',
        'scheduler:runs',
        'finance:transactions',
        'finance:disputes',
        'finance:payouts',
        'finance:purchase_orders',
        'depots',
        'costs:rate_cards',
        'costs:interstate',
        'costs:local',
        'fleet:transport',
        'fleet:containers',
        'fleet:trailers',
        'storage:units',
        'storage:jobs',
        'communications:templates',
        'communications:automations',
        'staff:team_directory',
        'customers',
        'affiliates',
        'forms',
        'reports',
        'tools:development',
        'help',
    ],
};

function populateNavigation(isTenantContext, roles, isMobile = false, features = {}) {
    const navItemsSet = new Set();

    let roleBasedNav = {};

    // console.log('isTenantContext = ', isTenantContext);

    if (isTenantContext) {
        roleBasedNav = tenantContextNav;
    } else {
        roleBasedNav = centralContextNav;
    }

    roles.forEach((role) => {
        if (role == 'DEVELOPER') {
            return;
        }

        const roleNavItems = roleBasedNav[role] || [];
        roleNavItems.forEach((item) => navItemsSet.add(item));
    });

    if (roles.includes('DEVELOPER')) {
        roleBasedNav['DEVELOPER'].forEach((item) => navItemsSet.add(item));
    }

    const navigation = [];

    navItemsSet.forEach((item) => {
        const [key, subKey] = item.split(':');

        if (subKey) {
            let mainNavItem = navigation.find((nav) => nav.name === allNavItems[key].name);

            if (!mainNavItem) {
                mainNavItem = { ...allNavItems[key], subitems: [] };
                navigation.push(mainNavItem);
            }

            if (!mainNavItem.subitems.find((sub) => sub.name === allNavItems[key].subitems[subKey].name)) {
                mainNavItem.subitems.push(allNavItems[key].subitems[subKey]);
            }
        } else {
            if (!navigation.find((nav) => nav.name === allNavItems[key].name)) {
                navigation.push(allNavItems[key]);
            }
        }
    });

    if (roles.includes('SUPER') || roles.includes('MOVEPRO_ADMIN') || roles.includes('DEVELOPER')) {
        navigation.forEach((navigationItem, navigationKey) => {
            if (navigationItem.name === 'My timesheets') {
                navigation.splice(navigationKey, 1);
            }
        });
    }

    if (isMobile) {
        navigation.forEach((navigationItem) => {
            if (navigationItem.name === 'Schedule') {
                navigationItem.subitems?.forEach((subitem, subitemKey) => {
                    if (subitem.name === 'Swimlane') {
                        navigationItem.subitems.splice(subitemKey, 1);
                    }
                });
            }
        });
    }

    // Feature guard: hide Waybills unless the tenant has the feature enabled.
    if (!features.waybills) {
        const waybillsIndex = navigation.findIndex((nav) => nav.name === allNavItems.waybills.name);
        if (waybillsIndex !== -1) {
            navigation.splice(waybillsIndex, 1);
        }
    }

    return navigation;
}
